export const CONFIG = {
  APP_NAME: 'Aliste-se',
  APP_AUTHOR: 'Comando',
  /** APK do app Android, servido de `storage/public/app` pela rota `/storage/*`. */
  MOBILE_APK_URL: '/storage/app/alistese.apk',
};
